"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable */


var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "36",
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.0907 35.9997C28.7306 35.9997 36.5452 28.185 36.5452 18.5452C36.5452 8.90534 28.7306 1.0907 19.0907 1.0907C9.45087 1.0907 1.63623 8.90534 1.63623 18.5452C1.63623 28.185 9.45087 35.9997 19.0907 35.9997Z",
    fill: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M32.909 14.9088C32.909 24.5487 25.0944 32.3633 15.4545 32.3633C11.5623 32.3633 7.96757 31.0893 5.0647 28.9356C8.24512 33.2219 13.3437 35.9997 19.091 35.9997C28.7309 35.9997 36.5455 28.185 36.5455 18.5452C36.5455 12.7976 33.7674 7.69883 29.4808 4.51843C31.6348 7.42141 32.909 11.0163 32.909 14.9088Z",
    fill: "#FFD13E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.63634 15.6361L7.38419 14.5151C2.93729 10.5395 0 7.90459 0 4.69181C0 2.06842 2.08302 -0.000244141 4.75116 -0.000244141C6.24906 -0.000244141 7.68845 0.693162 8.63634 1.7795C9.57253 0.693162 11.0236 -0.000244141 12.5215 -0.000244141C15.178 -0.000244141 17.2727 2.05686 17.2727 4.69181C17.2727 7.91615 14.3354 10.5395 9.88849 14.5266L8.63634 15.6361Z",
    fill: "#FF183F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.3636 15.6361L28.1115 14.5151C23.6646 10.5395 20.7273 7.90459 20.7273 4.69181C20.7273 2.06842 22.8103 -0.000244141 25.4785 -0.000244141C26.9764 -0.000244141 28.4157 0.693162 29.3636 1.7795C30.2998 0.693162 31.7509 -0.000244141 33.2488 -0.000244141C35.9053 -0.000244141 38 2.05686 38 4.69181C38 7.91615 35.0627 10.5395 30.6158 14.5266L29.3636 15.6361Z",
    fill: "#FF183F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.54541 18.1643V23.6707C8.54541 23.6707 8.94203 33.8006 19.0908 33.8006C29.2396 33.8006 29.6363 23.6707 29.6363 23.6707V18.1643H8.54541Z",
    fill: "black"
  }));
};

exports.default = _default;